export const BASE_URL = "https://nodejs.thetalentclub.co.in";
export const IMG_ADVERTSIMENT_URL = "https://thetalentclub.co.in/weblogin/";
export const IMG_URL = "https://thetalentclub.co.in/upload";
// export const BASE_URL = "http://localhost:30000";